/**
 * Detects Windows 10 older than version 2004 (build 19041) in the browser.
 *
 * On those versions the desktop app keeps its overlay out of a screen share
 * only when one window or a browser tab is shared; an entire-screen share
 * shows a dark box where the overlay is (desktop/docs/capture-protection.md).
 *
 * The user-agent string says "Windows NT 10.0" for every Windows 10 and 11,
 * so it cannot tell. Chrome and Edge report the Windows
 * UniversalApiContract major version as the User-Agent Client Hints
 * `platformVersion`: 1 to 8 for Windows 10 1507 to 1909, 10 or higher for
 * Windows 10 2004 and later, 13 or higher for Windows 11. Firefox and Safari
 * do not report it, so the answer there is "unknown" (null).
 */
const FIRST_FULL_PROTECTION_CONTRACT = 10; // Windows 10 version 2004

export function isOlderWindows10(platform, platformVersion) {
  if (platform !== 'Windows') return false;
  const major = Number.parseInt(String(platformVersion ?? '').split('.')[0], 10);
  return Number.isFinite(major) && major >= 1 && major < FIRST_FULL_PROTECTION_CONTRACT;
}

/** true / false, or null when this browser does not say. */
export async function detectOlderWindows10(navigatorLike = window.navigator) {
  const uaData = navigatorLike?.userAgentData;
  if (!uaData || typeof uaData.getHighEntropyValues !== 'function') return null;
  try {
    const { platform, platformVersion } = await uaData.getHighEntropyValues(['platformVersion']);
    if (platform !== 'Windows') return false;
    if (!platformVersion) return null;
    return isOlderWindows10(platform, platformVersion);
  } catch {
    return null;
  }
}
